import DynamicForm from 'components/DynamicForm'
import React, { Fragment } from 'react'

function ActivitySection(props) {
    const { form_groups } = props
  return (
   <>
           {
             form_groups && form_groups.map((item,index) => {
                 return (
                     <Fragment key={index}>
                     <DynamicForm formFields={item} />
                     </Fragment>
                 )
                })
              }
              </>
  )
}

export default ActivitySection